export default __webpack_public_path__ + "static/media/Oranges-Square.03f9dbe4.svg";